<template>
	<Modals
		:title="'Create a scheduled move'"
		:display="display"
		@show="closeModal"
	>
		<template #modal-content>
			<div class="schedule-create">
				<ScheduleAddEditForm
					class="schedule-create__fields"
					@hasError="updateHasErrorModal"
					@hasDateError="updateHasDateError"
					v-model="schedule"
				/>

				<div class="schedule-create__moved">
					<div class="schedule-create__moved-txt">
						List of client(s) to be moved:
					</div>
					<ul class="schedule-create__moved-list">
						<li
							class="schedule-create__moved-list-item"
							v-for="id in customers"
							:key="id"
						>
							<div v-if="customerById(id)">
								{{
									customerById(id).displayName ||
										customerById(id).dealershipGroup
								}}
							</div>
						</li>
					</ul>
				</div>
			</div>
		</template>
		<template #modal-footer>
			<ButtonGroup
				:items="[
					{
						id: 'saveButtonModal',
						className: 'btn--primary',
						labelText: 'Create a Scheduled Move',
						type: 'submit',
						disabled: disabledSaveActionButton,
						btnClick: saveAction
					},
					{
						id: 'cancelButtonModal',
						className: 'btn--link',
						labelText: 'Cancel',
						btnClick: closeModal
					}
				]"
			/>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import ScheduleAddEditForm from '@/sections/environment/schedule/shared/environment-schedule-add-edit-form.vue';
import ButtonGroup from '@/components/forms/button/button-group';
import { mapGetters, mapActions } from 'vuex';

export default {
	name: 'EnvironmentScheduleCreateModal',
	components: {
		Modals,
		ScheduleAddEditForm,
		ButtonGroup
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		display: {
			type: Boolean,
			default: false
		},
		customers: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			schedule: {},
			hasError: true,
			hasDateError: false
		};
	},
	computed: {
		...mapGetters('customers', ['customerById']),
		disabledSaveActionButton() {
			const {
				hasError,
				hasDateError,
				customers,
				schedule: { scheduledDate, moveToZoneId, releaseType, comment }
			} = this;

			const hasEmptyFields =
				!scheduledDate || !moveToZoneId || !releaseType || !comment;
			if (
				hasEmptyFields ||
				hasError ||
				hasDateError ||
				customers.length === 0 ||
				customers.length > 20
			) {
				return true;
			}

			return false;
		}
	},
	methods: {
		...mapActions('environments', {
			saveScheduleAction: 'saveSchedule'
		}),
		closeModal() {
			this.schedule = {};
			this.hasError = true;
			this.hasDateError = false;
			this.$emit('show', false);
		},
		async saveAction() {
			try {
				let payload = { ...this.schedule };
				payload.id = 0;
				payload.customers = this.customers.map(customer => {
					return {
						customerId: customer
					};
				});

				await this.saveScheduleAction(payload).then(response => {
					if (response) {
						this.$emit('reload', true);
					}
				});
			} catch (error) {
				console.log(error);
			}

			this.closeModal();
			this.$emit('reload', true);
		},
		updateHasErrorModal(val) {
			this.hasError = val;
		},
		updateHasDateError(val) {
			this.hasDateError = val;
		}
	}
};
</script>

<style lang="scss" scoped>
::v-deep .modal {
	@include mq($from: md) {
		width: 640px;
	}
}
::v-deep .modal__body {
	overflow: initial;
}

.schedule-create {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: $gutter-xxl;
	margin-bottom: $gutter-md;

	&__moved {
		display: flex;
		flex-direction: column;
		gap: $gutter-lg;
		font-size: $label-font-size;
	}

	&__moved-list {
		display: flex;
		flex-direction: column;
		gap: $gutter-sm;
		min-height: 284px;
		max-height: 284px;
		overflow-y: auto;
		@include scrollbar('small');
	}
}
</style>
